(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(6982);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6010);


var PageTitle = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__.clsx)("text-2xl xl:text-4xl font-bold mb-5 md:mb-8", className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageTitle);


/***/ }),

/***/ 3393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ skeletonLoader_SkeletonLoader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs


/**
 * @internal
 */
const SkeletonThemeContext = react.createContext({});

/* eslint-disable react/no-array-index-key */
const defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties({ baseColor, highlightColor, width, height, borderRadius, circle, direction, duration, enableAnimation = defaultEnableAnimation, }) {
    const style = {};
    if (direction === 'rtl')
        style['--animation-direction'] = 'reverse';
    if (typeof duration === 'number')
        style['--animation-duration'] = `${duration}s`;
    if (!enableAnimation)
        style['--pseudo-element-display'] = 'none';
    if (typeof width === 'string' || typeof width === 'number')
        style.width = width;
    if (typeof height === 'string' || typeof height === 'number')
        style.height = height;
    if (typeof borderRadius === 'string' || typeof borderRadius === 'number')
        style.borderRadius = borderRadius;
    if (circle)
        style.borderRadius = '50%';
    if (typeof baseColor !== 'undefined')
        style['--base-color'] = baseColor;
    if (typeof highlightColor !== 'undefined')
        style['--highlight-color'] = highlightColor;
    return style;
}
function Skeleton({ count = 1, wrapper: Wrapper, className: customClassName, containerClassName, containerTestId, circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = react.useContext(SkeletonThemeContext);
    const propsStyleOptions = { ...originalPropsStyleOptions };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions)) {
        if (typeof value === 'undefined') {
            delete propsStyleOptions[key];
        }
    }
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle,
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...styleOptionsToCssProperties(styleOptions),
    };
    let className = 'react-loading-skeleton';
    if (customClassName)
        className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for (let i = 0; i < countCeil; i++) {
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : '100%'; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === 'number'
                ? width * fractionalPart
                : `calc(${width} * ${fractionalPart})`;
            thisStyle = { ...thisStyle, width: fractionalWidth };
        }
        const skeletonSpan = (react.createElement("span", { className: className, style: thisStyle, key: i }, "\u200C"));
        if (inline) {
            elements.push(skeletonSpan);
        }
        else {
            // Without the <br />, the skeleton lines will all run together if
            // `width` is specified
            elements.push(react.createElement(react.Fragment, { key: i },
                skeletonSpan,
                react.createElement("br", null)));
        }
    }
    return (react.createElement("span", { className: containerClassName, "data-testid": containerTestId, "aria-live": "polite", "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : defaultEnableAnimation }, Wrapper
        ? elements.map((el, i) => react.createElement(Wrapper, { key: i }, el))
        : elements));
}

function SkeletonTheme({ children, ...styleOptions }) {
    return (React.createElement(SkeletonThemeContext.Provider, { value: styleOptions }, children));
}



// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/skeleton.css
var skeleton = __webpack_require__(4714);
;// CONCATENATED MODULE: ./src/components/ui/skeletonLoader/SkeletonLoader.tsx






var SkeletonLoader = function(_param) {
    var className = _param.className, rest = _objectWithoutProperties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        baseColor: "#47536a",
        highlightColor: "#69718d",
        className: className ? "rounded-xl ${className}" : "rounded-xl"
    }));
};
/* harmony default export */ var skeletonLoader_SkeletonLoader = (SkeletonLoader);


/***/ }),

/***/ 3893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Table_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4193);
/* harmony import */ var _Table_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Table_module_scss__WEBPACK_IMPORTED_MODULE_1__);


var Table = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Table_module_scss__WEBPACK_IMPORTED_MODULE_1___default().table_wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("table", {
            className: (_Table_module_scss__WEBPACK_IMPORTED_MODULE_1___default().table),
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Table);


/***/ }),

/***/ 515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useOnScreen; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(603);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


var useOnScreen = function(ref) {
    var playOnce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isOnScreen = _$ref[0], setIsOnScreen = _$ref[1];
    var observerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    if (isOnScreen && playOnce && observerRef.current) {
        observerRef.current.disconnect();
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        observerRef.current = new IntersectionObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            setIsOnScreen(entry.isIntersecting);
        }, {
            threshold: 0.1
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (observerRef.current && ref.current) {
            observerRef.current.observe(ref.current);
        }
        return function() {
            observerRef.current && observerRef.current.disconnect();
        };
    }, [
        ref
    ]);
    return isOnScreen;
};


/***/ }),

/***/ 6982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/providers/meta/Meta.tsx
var Meta = __webpack_require__(8222);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/ui/skeletonLoader/SkeletonLoader.tsx + 3 modules
var SkeletonLoader = __webpack_require__(3393);
// EXTERNAL MODULE: ./src/services/crypto/cryptoService.ts
var cryptoService = __webpack_require__(2395);
// EXTERNAL MODULE: ./src/hooks/useOnScreen.ts
var useOnScreen = __webpack_require__(515);
// EXTERNAL MODULE: ./src/components/common/coinSection/CoinSection.module.scss
var CoinSection_module = __webpack_require__(725);
var CoinSection_module_default = /*#__PURE__*/__webpack_require__.n(CoinSection_module);
;// CONCATENATED MODULE: ./src/components/common/coinSection/CoinSectionInfo.tsx


var CoinSectionInfo = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-lg",
                        children: [
                            "Price (",
                            data.symbol,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-4xl md:text-5xl font-bold mb-2",
                        children: data.price
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-lg mb-4",
                        children: [
                            "Change 24H:",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: data.change24H[2] === "-" ? "text-red-500 mx-2" : "text-green-500 mx-2",
                                children: data.change24H
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "p-1 rounded ".concat(data.change24HPct.startsWith("-") ? "bg-red-500 text-primaryLightColor" : "bg-green-500 text-primaryDarkColor"),
                                children: [
                                    data.change24HPct,
                                    "%"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: (CoinSection_module_default()).info_list,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (CoinSection_module_default()).info_list_title,
                                children: "Mkt. cap:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: data.marketCap
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (CoinSection_module_default()).info_list_title,
                                children: "Total Volume:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: data.totalVolume
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (CoinSection_module_default()).info_list_title,
                                children: "Total Volume To:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: data.totalVolumeTo
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (CoinSection_module_default()).info_list_title,
                                children: "Open 24H:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: data.open24H
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (CoinSection_module_default()).info_list_title,
                                children: "Low/High 24h:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    data.low24H,
                                    " - ",
                                    data.high24H
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (CoinSection_module_default()).info_list_title,
                                children: "Last Volume:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: data.lastVolume
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (CoinSection_module_default()).info_list_title,
                                children: "Last Volume To:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: data.lastVolumeTo
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (CoinSection_module_default()).info_list_title,
                                children: "Top Tier Volume:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: data.topTierVolume
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (CoinSection_module_default()).info_list_title,
                                children: "Top Tier Volume To:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: data.topTierVolumeTo
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var coinSection_CoinSectionInfo = (CoinSectionInfo);

;// CONCATENATED MODULE: ./src/components/common/coinSection/CoinSection.tsx








var DynamicCoinChart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(757), __webpack_require__.e(389), __webpack_require__.e(679)]).then(__webpack_require__.bind(__webpack_require__, 3679));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3679)
            ];
        }
    },
    ssr: false
});
var CoinSection = function(param) {
    var coinSymbol = param.coinSymbol, coinTitle = param.coinTitle;
    var ref = (0,react.useState)(true), skip = ref[0], setSkip = ref[1];
    var ref1 = (0,cryptoService/* useGetCoinQuery */.Gm)(coinSymbol, {
        skip: skip
    }), data = ref1.data, isLoading = ref1.isLoading, error = ref1.error;
    var coinRef = (0,react.useRef)(null);
    var isVisible = (0,useOnScreen/* useOnScreen */.R)(coinRef);
    (0,react.useEffect)(function() {
        if (isVisible) setSkip(false);
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "card-block p-3 md:p-7",
        ref: coinRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: "flex flex-col md:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center mb-3 md:mb-0 md:mr-14",
                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* default */.Z, {
                                    width: 120,
                                    height: 120,
                                    circle: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* default */.Z, {
                                    height: 40
                                })
                            ]
                        }) : !isLoading && data ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    width: 120,
                                    height: 120,
                                    objectFit: "cover",
                                    src: data.logoUrl,
                                    alt: data.symbol
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-2xl md:text-4xl font-bold",
                                    children: coinTitle
                                })
                            ]
                        }) : null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        children: isLoading || !data && !error ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* default */.Z, {
                                    width: 70,
                                    height: 25
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* default */.Z, {
                                    width: 240,
                                    height: 50
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* default */.Z, {
                                    width: 270,
                                    height: 28
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* default */.Z, {
                                    height: 80
                                })
                            ]
                        }) : !isLoading && data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(coinSection_CoinSectionInfo, {
                            data: data
                        }) : null
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-2xl text-red-500",
                        children: "Something went wrong. Please try again later."
                    })
                ]
            }),
            isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicCoinChart, {
                coinSymbol: coinSymbol
            })
        ]
    });
};
/* harmony default export */ var coinSection_CoinSection = (CoinSection);

// EXTERNAL MODULE: ./src/components/ui/table/Table.tsx
var Table = __webpack_require__(3893);
;// CONCATENATED MODULE: ./src/components/common/topListTable/TopListTableItem.tsx


var TopListTableItem = function(param) {
    var coin = param.coin, index = param.index;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
        className: "border-t border-t-gray-600 text-left",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: index + 1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mr-2 leading-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            width: 30,
                            height: 30,
                            objectFit: "cover",
                            src: coin.logoUrl,
                            alt: coin.symbol
                        })
                    }),
                    coin.name
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: coin.symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: coin.price
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: coin.marketCap
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: coin.totalVolume
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                className: coin.change24Hours.startsWith("-") ? "text-red-500" : "text-green-500",
                children: coin.change24Hours
            })
        ]
    }, coin.symbol);
};
/* harmony default export */ var topListTable_TopListTableItem = (TopListTableItem);

;// CONCATENATED MODULE: ./src/components/common/topListTable/TopListTable.tsx



var TopListTable = function(param) {
    var coinsData = param.coinsData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                    className: "text-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            children: "Rank"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            children: "Coin"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            children: "Symbol"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            children: "Price"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            children: "Market Cap"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            children: "Total Volume"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            children: "% 24H"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                children: coinsData.map(function(coin, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(topListTable_TopListTableItem, {
                        coin: coin,
                        index: i
                    }, coin.symbol);
                })
            })
        ]
    });
};
/* harmony default export */ var topListTable_TopListTable = (TopListTable);

// EXTERNAL MODULE: ./src/components/ui/pageTitle/PageTitle.tsx
var PageTitle = __webpack_require__(1269);
;// CONCATENATED MODULE: ./src/components/screens/home/TopList.tsx





var TopList = function() {
    var ref = (0,cryptoService/* useGetToplistQuery */.g9)(""), data = ref.data, isLoading = ref.isLoading, error = ref.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "card-block p-3 md:p-7",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
                children: "Top List Cryptocurrencies"
            }),
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* default */.Z, {
                count: 10,
                height: 53
            }),
            data && !error && data.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(topListTable_TopListTable, {
                coinsData: data
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-2xl text-red-500",
                children: "Something went wrong. Please try again later."
            })
        ]
    });
};
/* harmony default export */ var home_TopList = (TopList);

;// CONCATENATED MODULE: ./src/components/screens/home/Home.tsx



var Home = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container flex flex-col gap-14",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_TopList, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(coinSection_CoinSection, {
                coinSymbol: "BTC",
                coinTitle: "Bitcoin"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(coinSection_CoinSection, {
                coinSymbol: "ETH",
                coinTitle: "Ethereum"
            })
        ]
    });
};
/* harmony default export */ var home_Home = (Home);

;// CONCATENATED MODULE: ./src/pages/index.tsx



var HomePage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* Meta */.h, {
        title: "Home",
        description: "Cryptocurrencies notebook",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(home_Home, {})
    });
};
/* harmony default export */ var pages = (HomePage);


/***/ }),

/***/ 8222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Meta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3293);




var Meta = function(param) {
    var title = param.title, description = param.description, _image = param.image, image = _image === void 0 ? null : _image, children = param.children;
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().asPath;
    var currentUrl = "".concat("https://crypto-pet-front-88oi.vercel.app").concat(asPath);
    var siteName = "Crypto notebook";
    var ogLogo = "".concat("https://crypto-pet-front-88oi.vercel.app", "/static/images/og-logo.jpg");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        itemProp: "headline",
                        children: "".concat(title, " | ").concat(siteName)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        itemProp: "description",
                        name: "description",
                        content: (0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .onlyText */ .RJ)(description, 152)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: currentUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: "en"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "".concat(title, " | ").concat(siteName)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: currentUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: image || ogLogo
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: siteName
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: (0,_utils_index__WEBPACK_IMPORTED_MODULE_3__/* .onlyText */ .RJ)(description, 197)
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "".concat(title, " | ").concat(siteName)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    })
                ]
            }),
            children
        ]
    });
};


/***/ }),

/***/ 725:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"info_list":"CoinSection_info_list__OA4WB","info_list_title":"CoinSection_info_list_title__k4d4G"};

/***/ }),

/***/ 4193:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"table_wrapper":"Table_table_wrapper__fuKj6","table":"Table_table__d_fUq"};

/***/ }),

/***/ 4714:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 603:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArray(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);